import type { SVGProps } from 'react';

const SvgTopLine = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 20 1" {...props}>
    <line x1="0" y1="0" x2="20" y2="0" stroke="black" strokeWidth={2} />
  </svg>
);

export default SvgTopLine;
